<template>
    <div>
        <h1>Category Details page, id: {{ $route.params.id }}</h1>
    </div>
</template>

<script>
export default {

}
</script>
